"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faBell_1 = require("@fortawesome/pro-regular-svg-icons/faBell");
var firestore_1 = require("firebase/firestore");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var CircleIconButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/CircleIconButton"));
var DropdownMenu_1 = __importDefault(require("shared/components/DropdownMenu"));
var hooks_1 = require("utils/hooks");
var base_1 = require("utils/selectors/base");
var other_1 = require("utils/selectors/other");
var single_1 = require("utils/selectors/single");
var NotificationList_1 = __importDefault(require("./NotificationList"));
var NotificationsDropdown = function () {
    var _a = __read(react_1.default.useState(null), 2), notifAnchorEl = _a[0], setNotifAnchorEl = _a[1];
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var isImpersonating = (0, react_redux_1.useSelector)(base_1.selectIsImpersonating);
    var unreadNotificationsCount = (0, react_redux_1.useSelector)(other_1.selectUnreadNotificationsCount);
    var _b = __read((0, hooks_1.useSubmitter)('users', profile.id), 1), setMergeProfile = _b[0];
    react_1.default.useEffect(function () {
        if (!notifAnchorEl || isImpersonating) {
            return undefined;
        }
        var timeout = setTimeout(function () {
            var _a;
            return profile.companyId && setMergeProfile({ notificationsLastReadOnPerCompany: (_a = {}, _a[profile.companyId] = firestore_1.Timestamp.now(), _a) });
        }, 2000);
        return function () { return clearTimeout(timeout); };
    }, [!!notifAnchorEl]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CircleIconButton_1.default, { icon: faBell_1.faBell, iconSize: 14, "aria-controls": "notifs", "aria-haspopup": "true", hasRedDot: unreadNotificationsCount > 0, onClick: function (e) { return setNotifAnchorEl(e.currentTarget); } }), (0, jsx_runtime_1.jsx)(DropdownMenu_1.default, __assign({ id: "notifs", anchorEl: notifAnchorEl, open: !!notifAnchorEl, onClose: function () { setNotifAnchorEl(null); } }, { children: (0, jsx_runtime_1.jsx)(NotificationList_1.default, {}) }))] }));
};
exports.default = NotificationsDropdown;
